import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "教育",
  icon: "🧠",
  templates: [
    {
      title: "简单解释",
      content: `用清晰且吸引人的方式向听众解释[疫苗如何训练免疫系统]的主题。
- 想象你在向[一个没有科学背景的好奇少年]解释。
- 使用一个贴切的类比：[把它比作消防演习——你为某件事练习，这样当真正发生时你就准备好了]。
- 避免专业术语；当需要使用技术词汇时，立即用通俗语言解释。
- 用温暖、鼓励的语气写作，让听众感觉自己很聪明，而不是被居高临下地对待。`
    },
    {
      title: "纪录片旁白",
      content: `写一段纪录片风格的旁白叙述。
- 主题：[曼谷街头美食摊贩的日常生活]。
- 角度：[看似简单的菜肴背后的技艺、骄傲和代代相传的知识]。
- 语气：[尊重、生动、从容不迫——让画面有呼吸的空间]。
- 包含帮助听众想象和感受环境的感官细节：[锅铲翻炒的滋滋声、清晨市场的潮湿空气、一位已经重复了上万次的摊贩精准的手部动作]。
- 使用现在时态以增强即视感。`
    },
    {
      title: "冥想引导",
      content: `写一段用于聆听的冥想引导脚本。
- 目标：[释放漫长工作日后的紧张感，平静地进入夜晚]。
- 引导听众想象[日落时分宁静的湖畔——温暖的光线洒在水面上，微风轻拂，远处的鸟儿正安静地归巢]。
- 语气：[平静、从容、扎实]。
- 大约口语时长：[8分钟]。
- 在指令之间使用大量自然停顿（用"……"标记）。保持句子简短温和。避免突然的能量转变。`
    }
  ]
};
